import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import { DataTable } from '../../../../design/dataTable/DataTable';
import { IAdminPageProperties } from '../../IAdminPageProperties';
import { TagEntityAdminDomain } from './store/TagEntityAdminDomain';

export interface ITagEntityAdminTableProperties extends IAdminPageProperties { }

export const TagEntityAdminTable = observer(({ layoutDomain }: ITagEntityAdminTableProperties) => {
  useEffect(() => {
    layoutDomain.ui.pagePadding.setValue(0)
    return () => layoutDomain.ui.pagePadding.setValue(24)
  }, [])
  const [domain] = useState<TagEntityAdminDomain>(new TagEntityAdminDomain(layoutDomain));

  return <DataTable dataTableDomain={domain} tableHeight={window.innerHeight} />;
});
